import React, { useState, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Toast, Form } from "react-bootstrap";
import { Link,  useHistory } from "react-router-dom";

import axios from "axios";
import { Helmet } from "react-helmet";
import Localbase from "localbase";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import ENDPOINT from "../../data/ENDPOINT";

import "../../assets/css/Signup.css"; // Assuming CSS from lyfax design

export default function SignupPage() {
  // const navigate = useNavigate();
  const db = new Localbase("db");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    referralCode: "",
    agreeTerms: false,
  });

  const [showReferral, setShowReferral] = useState(false);
  const [toast, setToast] = useState({ show: false, title: "", message: "" });
  const [accountExists, setAccountExists] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Backend logics, states, and functionalities from Skills Uprise
  const [emailerror, setemailerror] = useState(null);
  const [fnameerror, setfnameerror] = useState(null);
  const [lnameerror, setlnameerror] = useState(null);
  const [phoneerror, setphoneerror] = useState(null);
  const [passworderror, setpassworderror] = useState(null);
  const [terms, setterms] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    db.collection("paths")
      .doc("rf_code")
      .get()
      .then((data) => {
        if (data && data.rf_code) {
          setFormData((prev) => ({ ...prev, referralCode: data.rf_code }));
          setShowReferral(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching referral code:", error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Clear errors (from lyfax, but minimal as per skills uprise)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) {
      setphoneerror("Enter 10 digit phone number");
      return;
    } else {
      setphoneerror(null);
      setIsFetching(true);
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("first_name", formData.firstName);
        formDataToSend.append("last_name", formData.lastName);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("phone", formData.phone);
        formDataToSend.append("password", formData.password);
        if (formData.referralCode)
          formDataToSend.append("referral_code", formData.referralCode);

        const res = await axios.post(ENDPOINT + "signup.php", formDataToSend, {
          headers: { "content-type": "multipart/form-data" },
        });

        setIsFetching(false);

        if (res.data.status === "success") {
          if (res.data.account_status === "verified") {
            // usernameavailability not in skills uprise, skipped
          }
          if (res.data.account_status === "active") {
            setAccountExists(true);
          } else if (
            res.data.account_exists === "false" ||
            res.data.verification_code
          ) {
            window.location.href = "/vcp/" + res.data.verification_code;

          }
        } else {
          setToast({
            show: true,
            title: "Error",
            message: res.data.message || "Registration failed",
          });
        }
      } catch (error) {
        setToast({
          show: true,
          title: "Error",
          message: "An error occurred during registration",
        });
      } finally {
        setIsFetching(false);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>SignUp | Create New Account | Skills Uprise</title>
        <meta
          name="description"
          content="Signup into skills uprise and join placement guaranteed training programs | online courses | offline courses | self-paced courses"
        />
        <meta name="keywords" content="skills uprise, signup, join, account" />
      </Helmet>

      <Modal
        open={accountExists}
        onClose={() => setAccountExists(false)}
        closeAfterTransition
      >
        <Fade in={accountExists}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 400 },
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
              p: 3,
              outline: "none",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{ mb: 2, fontWeight: 700, color: "#0f172a" }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>Account Already Exists!</span>
                <CloseIcon
                  onClick={() => setAccountExists(false)}
                  sx={{ cursor: "pointer", color: "#6c757d" }}
                />
              </div>
            </Typography>
            <Typography sx={{ mt: 2, mb: 3, color: "#6c757d" }}>
              This email is already registered. Please log in to continue.
            </Typography>
            <div className="d-flex gap-2">
              <button
                onClick={() => setAccountExists(false)}
                className="btn btn-outline-secondary flex-grow-1"
              >
                Cancel
              </button>
              <Link to="/login" className="btn btn-primary flex-grow-1">
                Go to Login
              </Link>
            </div>
          </Box>
        </Fade>
      </Modal>

      <Toast
        onClose={() => setToast({ ...toast, show: false })}
        show={toast.show}
        delay={5000}
        autohide
        className="position-fixed top-0 end-0 m-3"
        style={{ zIndex: 9999 }}
      >
        <Toast.Header>
          <strong className="me-auto">{toast.title}</strong>
        </Toast.Header>
        <Toast.Body>{toast.message}</Toast.Body>
      </Toast>

      <div className="cybersecurity-signup min-vh-100 d-flex justify-content-center align-items-center p-3">
        <div
          className="signup-container w-100 d-flex"
          style={{
            maxWidth: "1200px",
            overflow: "hidden",
            borderRadius: "20px",
          }}
        >
          {/* Left Section - Hero from lyfax */}
          <div
            className="hero-section d-none d-lg-flex flex-column justify-content-center align-items-center"
            style={{
              flex: 1,
              minHeight: "600px",
              position: "relative",
            }}
          >
            {/* Animated background shapes */}
            <div className="hero-bg-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <div
              className="hero-cards"
              style={{ position: "relative", zIndex: 2 }}
            >
              {/* Cybersecurity illustration - Retro computer */}
              <svg
                viewBox="0 0 400 400"
                className="cyber-illustration"
                style={{ width: "320px", height: "320px" }}
              >
                {/* Monitor screen */}
                <rect
                  x="80"
                  y="80"
                  width="240"
                  height="180"
                  rx="20"
                  fill="none"
                  stroke="#e9bd0fff"
                  strokeWidth="3"
                  opacity="0.8"
                />
                {/* Screen inner glow */}
                <rect
                  x="90"
                  y="90"
                  width="220"
                  height="160"
                  rx="15"
                  fill="#0d3d2c"
                  opacity="0.3"
                />
                {/* Scanlines effect */}
                <g opacity="0.2">
                  <line
                    x1="90"
                    y1="100"
                    x2="310"
                    y2="100"
                    stroke="#f6c411ff"
                    strokeWidth="1"
                  />
                  <line
                    x1="90"
                    y1="115"
                    x2="310"
                    y2="115"
                    stroke="#efbf14ff"
                    strokeWidth="1"
                  />
                  <line
                    x1="90"
                    y1="130"
                    x2="310"
                    y2="130"
                    stroke="#f2c40dff"
                    strokeWidth="1"
                  />
                  <line
                    x1="90"
                    y1="145"
                    x2="310"
                    y2="145"
                    stroke="#e9b817ff"
                    strokeWidth="1"
                  />
                  <line
                    x1="90"
                    y1="160"
                    x2="310"
                    y2="160"
                    stroke="#f1da12ff"
                    strokeWidth="1"
                  />
                  <line
                    x1="90"
                    y1="175"
                    x2="310"
                    y2="175"
                    stroke="#eeca15ff"
                    strokeWidth="1"
                  />
                </g>
                {/* Screen content dots */}
                <circle cx="140" cy="120" r="4" fill="#ec4899" opacity="0.6" />
                <circle cx="160" cy="135" r="3" fill="#10d981" opacity="0.7" />
                <circle cx="240" cy="125" r="5" fill="#f59e0b" opacity="0.5" />

                {/* Monitor stand */}
                <rect
                  x="160"
                  y="270"
                  width="80"
                  height="60"
                  rx="5"
                  fill="none"
                  stroke="#f0dd11ff"
                  strokeWidth="2.5"
                  opacity="0.7"
                />
                {/* Stand base */}
                <ellipse
                  cx="200"
                  cy="330"
                  rx="70"
                  ry="15"
                  fill="none"
                  stroke="#edc00dff"
                  strokeWidth="2.5"
                  opacity="0.6"
                />

                {/* Floating geometric shapes */}
                <circle cx="50" cy="60" r="12" fill="#ec4899" opacity="0.4" />
                <circle cx="350" cy="70" r="15" fill="#f59e0b" opacity="0.3" />
                <circle cx="370" cy="280" r="10" fill="#10d981" opacity="0.5" />
              </svg>
            </div>
          </div>

          {/* Right Section - Form with lyfax design, but skills uprise logic */}
          <div
            className="form-section"
            style={{ flex: 1, padding: "2.5rem 2rem" }}
          >
            <div className="form-wrapper">
              <div className="text-center mb-5">
                <h1 className="signup-title mb-2">Create Account</h1>
                <p className="signup-subtitle">
                  Already have an account?{" "}
                  <Link style={{  color:" #ea8245"}} to="/login" className="login-link">
                    Log in
                  </Link>
                </p>
              </div>

              {/* Google Sign Up */}
              {/* <button className="google-signup-btn w-100 mb-3">
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  style={{ marginRight: "8px" }}
                >
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Sign up with Google
              </button> */}

              <div className="divider-section">
                <span>Or</span>
              </div>

              <Form onSubmit={handleSubmit} noValidate>
                {/* Name Row */}
                <div className="form-row mb-3">
                  <div className="form-col">
                    <input
                      type="text"
                      name="firstName"
                      className={`form-field ${fnameerror ? "has-error" : ""}`}
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="First name"
                    />
                    {fnameerror && (
                      <span className="error-text">{fnameerror}</span>
                    )}
                  </div>
                  <div className="form-col">
                    <input
                      type="text"
                      name="lastName"
                      className={`form-field ${lnameerror ? "has-error" : ""}`}
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Last name"
                    />
                    {lnameerror && (
                      <span className="error-text">{lnameerror}</span>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className={`form-field ${emailerror ? "has-error" : ""}`}
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email address"
                  />
                  {emailerror && (
                    <span className="error-text">{emailerror}</span>
                  )}
                </div>

                {/* Phone */}
                <div className="mb-3">
                  <input
                    type="tel"
                    name="phone"
                    className={`form-field ${phoneerror ? "has-error" : ""}`}
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                  />
                  {phoneerror && (
                    <span className="error-text">{phoneerror}</span>
                  )}
                </div>

                {/* Password with visibility toggle (from lyfax) */}
                <div className="mb-3">
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className={`form-field ${
                        passworderror ? "has-error" : ""
                      }`}
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Password"
                      style={{ paddingRight: "40px" }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="password-toggle-btn"
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                  {passworderror && (
                    <span className="error-text">{passworderror}</span>
                  )}
                </div>

                {/* Referral Code from skills uprise logic */}
                <div className="mb-3">
                  {!showReferral ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowReferral(true);
                      }}
                      className="referral-toggle"
                    >
                      Have a referral code?
                    </a>
                  ) : (
                    <input
                      type="text"
                      name="referralCode"
                      className="form-field"
                      value={formData.referralCode}
                      onChange={handleChange}
                      placeholder="Enter referral code"
                    />
                  )}
                </div>

                {/* Terms Checkbox from skills uprise */}
                <div className="checkbox-group mb-4">
                  <input
                    type="checkbox"
                    name="agreeTerms"
                    id="agreeTerms"
                    checked={formData.agreeTerms}
                    onChange={handleChange}
                  />
                  <label htmlFor="agreeTerms">
                    By creating an account, I agree with{" "}
                    <a href="#" className="policy-link">
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a href="#" className="policy-link">
                      Terms of Service
                    </a>
                    .
                  </label>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="submit-btn w-100"
                  disabled={isFetching || !formData.agreeTerms}
                >
                  {isFetching ? "Creating Account..." : "Create Account"}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}